/* Phrase scroll-reveal v2. Typed, restrained entrance motion.
   - T1 whole-section fade-rise (fallback for non-grid sections).
   - T2 staggered children of known grids/rails (the workhorse).
   - T3 image cover-scale inside clean media boxes.
   All classes are added by JS, so content is never hidden when JS is off.
   The first section (hero / LCP) is never animated; anything above the fold shows immediately.
   STICKY-SAFETY: product/cart templates are skipped wholesale, and no section that contains
   a position:sticky descendant ever gets a section transform (which would break the sticky). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var main = document.getElementById('MainContent');
  if (!main) return;
  var body = document.body;
  if (body.classList.contains('template-product') || body.classList.contains('template-cart')) return;

  // Repeating children of grids/rails that should stagger in (T2). Specific phrase-* classes only.
  var STAGGER = ['.phrase-best__cell', '.phrase-cs__card', '.phrase-mosaic__cell', '.phrase-cats__tile', '.phrase-fits__tile'];
  // Single-image media boxes that should cover-scale in (T3).
  var IMAGES = ['.phrase-cs__media img', '.phrase-mosaic__cell img', '.phrase-cats__tile img', '.phrase-fits__media img'];
  // Any of these inside a section means it bears a sticky child: never apply T1 (a transform) to it.
  var STICKY_SEL = '[data-sticky], .phrase-sticky, #ProductSticky, [style*="position: sticky"], [style*="position:sticky"]';

  function makeObs(cb) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return io;
  }

  function init() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    function aboveFold(el) { return el.getBoundingClientRect().top < vh * 0.85; }
    function slice(list) { return Array.prototype.slice.call(list); }
    function reveal(el) { el.classList.add('is-in'); }

    // --- T3 tagging FIRST so container reveals (below) can also lift their images ---
    var imgObs = makeObs(reveal);
    IMAGES.forEach(function (sel) {
      slice(main.querySelectorAll(sel)).forEach(function (img) {
        img.classList.add('phrase-reveal-img');
        if (aboveFold(img)) reveal(img);
        else imgObs.observe(img);            // fallback for images not inside a tracked container
      });
    });

    // --- T2: staggered children, grouped by their parent container.
    //     When a container enters view it lifts its children AND any images inside it
    //     (this is what reveals rail images that are scrolled off-screen to the right). ---
    var childObs = makeObs(function (container) {
      (container.__phChildren || []).forEach(reveal);
      slice(container.querySelectorAll('.phrase-reveal-img')).forEach(reveal);
    });
    STAGGER.forEach(function (sel) {
      var groups = [];
      slice(main.querySelectorAll(sel)).forEach(function (n) {
        var p = n.parentNode, g = null;
        for (var k = 0; k < groups.length; k++) { if (groups[k].parent === p) { g = groups[k]; break; } }
        if (!g) { g = { parent: p, items: [] }; groups.push(g); }
        g.items.push(n);
      });
      groups.forEach(function (g) {
        g.items.forEach(function (c, i) {
          c.classList.add('phrase-reveal-child');
          c.style.setProperty('--i', Math.min(i, 8));
        });
        g.parent.__phChildren = g.items;
        if (aboveFold(g.parent)) {
          g.items.forEach(reveal);
          slice(g.parent.querySelectorAll('.phrase-reveal-img')).forEach(reveal);
        } else {
          childObs.observe(g.parent);
        }
      });
    });

    // --- T1: whole-section fade-rise, only for sections WITHOUT staggered children and WITHOUT a sticky child ---
    var sections = slice(main.querySelectorAll(':scope > .shopify-section'));
    if (!sections.length) sections = slice(main.querySelectorAll('.shopify-section'));
    var secObs = makeObs(reveal);
    sections.forEach(function (s, idx) {
      if (idx === 0) return;                    // hero / LCP, never animated
      if (s.querySelector(STICKY_SEL)) return;  // sticky-safety: never transform a sticky ancestor
      var hasChildAnim = STAGGER.some(function (sel) { return s.querySelector(sel); });
      if (hasChildAnim) return;                 // its children carry the motion (T2); leave the wrapper put
      s.classList.add('phrase-reveal');
      if (aboveFold(s)) reveal(s);
      else secObs.observe(s);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
